import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ActionServiceService } from '../../suivi/plananalytique/actions/action/action.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddPdcComponent } from '../add-pdc/add-pdc.component';
import { EditionPdcComponent } from '../edition-pdc/edition-pdc.component';
import { Constant } from 'src/app/shared/service/utils/contant';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-listing-pdc',
  standalone: false,
  templateUrl: './listing-pdc.component.html',
  styleUrl: './listing-pdc.component.scss'
})


export class ListingPdcComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  pdcData: any = [];
  validationform: UntypedFormGroup;
  modalRef: NgbModalRef | null = null;

  itemToDelete!: any;
  paginatedProjets = [];
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  filteredData: any[] = [];
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  constructor(
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ActionServiceService: FecthDataService,
    private ngxService: NgxUiLoaderService,

  ) {
    this.ActionServiceService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.getPdc();
    });
  }

  ngOnInit(): void {
  }

  getPdc() {
    this.isLoading === false;
    this.paramservice.getPdc().subscribe(
      (response: any) => {
        this.pdcData = response.data;
        this.filteredData = [...this.pdcData];
        this.totalRecords = this.filteredData.length;
        this.updatePaginatedProjets();
        this.isLoading = true;
        //console.log("this.pdcData", this.pdcData);
      },
      (error) => {
        //console.log("une erreur est survenu", error);
      }
    );
  }
  onPageChangeProjets(event) {
    this.firstProjets = event.first;
    this.rowsProjets = event.rows;
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredData.slice(start, end);
  }


  filterData() {
  const lowerSearchTerm = this.searchTerm.toLowerCase();

  if (!lowerSearchTerm.trim()) {
    this.filteredData = [...this.pdcData];
  } else {
    const searchWords = lowerSearchTerm.split(' ').filter(w => w);

    this.filteredData = this.pdcData.filter((item: any) => {
      const libelle = item.libelle?.toLowerCase() || "";
      const direction = item.direction_id?.toLowerCase?.() || ""; // si direction est string

      return searchWords.every(word =>
        libelle.includes(word) ||
        direction.includes(word)
      );
    });
  }

  // mise à jour pagination
  this.totalRecords = this.filteredData.length;
  this.firstProjets = 0;
  this.updatePaginatedProjets();
}
  openModal() {

    this.modalService.open(AddPdcComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg'

    });
  }

  EditModal(action: any) {
    //console.log("action",action);
    
    this.localstorage.savePdcProjet(action)
    const modalRef = this.modalService.open(EditionPdcComponent, {
      backdrop: 'static',
      size: 'xl',
      centered: true,
    },);
  }

  confirmSuppression(event: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer cette action ' + event.libelle + '?',

      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deletePdc(event.reference).subscribe(
          (response: any) => {
            //console.log("la reponse du webserice", response);
            this.messageService.add({ severity: 'succes', summary: Constant.suiviTitle, detail: response.message });
            this.getPdc();
            this.ngxService.stop();

          },
          (error) => {
            //console.log("une erreur est survenu", error);
            this.messageService.add({ severity: 'warn', summary: Constant.suiviTitle, detail: error });
            this.ngxService.stop();
          },
        )
      },
      // reject: () => {
      //     this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
      // }
    });
  }



}